import React, { useState } from 'react';
import './CertificationTracker.css';
import CAMSCourse from './CAMSCourse';

// Professional Certification track: CrossReg Nexus exam-preparation courses.
// CAMS is live; the others are planned and shown as "Coming soon" in the same card format.
const UPCOMING_COURSES = [
  {
    id: 'cgss-prep', icon: '🌐', title: 'CGSS Exam Preparation',
    description: 'Global sanctions regimes, screening programs, ownership and control, evasion typologies and sanctions investigations — with hands-on screening labs in CrossRegGuard.',
    highlights: ['📚 Study modules', '📝 Final exam', '🛠 Sanctions labs', '🎖️ Certificate'],
  },
  {
    id: 'ckyca-prep', icon: '🪪', title: 'CKYCA Exam Preparation',
    description: 'Customer identification, due diligence, beneficial ownership, risk rating and periodic reviews — practised on real onboarding and EDD workflows in CrossRegGuard.',
    highlights: ['📚 Study modules', '📝 Final exam', '🛠 KYC labs', '🎖️ Certificate'],
  },
  {
    id: 'ccas-prep', icon: '₿', title: 'CCAS Exam Preparation',
    description: 'Crypto-asset financial crime: blockchain fundamentals, VASP obligations, the travel rule, tracing and typologies — with wallet tracing labs in CrossRegGuard.',
    highlights: ['📚 Study modules', '📝 Final exam', '🛠 Crypto labs', '🎖️ Certificate'],
  },
  {
    id: 'cfe-prep', icon: '🔍', title: 'CFE Exam Preparation',
    description: 'Financial transactions and fraud schemes, law, investigation and fraud prevention and deterrence — with case-building labs in CrossRegGuard.',
    highlights: ['📚 Study modules', '📝 Final exam', '🛠 Investigation labs', '🎖️ Certificate'],
  },
  {
    id: 'ica-aml-prep', icon: '🎓', title: 'International Diploma in AML Preparation',
    description: 'The international AML/CFT framework and its practical application across sectors, risk assessment and program design — with program-building labs in CrossRegGuard.',
    highlights: ['📚 Study modules', '📝 Assessments', '🛠 Program labs', '🎖️ Certificate'],
  },
];

export function CertificationTracker({ userId, userEmail }) {
  const [showCAMSCourse, setShowCAMSCourse] = useState(false);

  if (showCAMSCourse) {
    return (
      <div className="certification-tracker">
        <div className="cert-header">
          <button onClick={() => setShowCAMSCourse(false)} className="back-to-certs-btn">
            ← Back to Certifications
          </button>
        </div>
        <CAMSCourse userId={userId} userEmail={userEmail} onComplete={() => setShowCAMSCourse(false)} />
      </div>
    );
  }

  return (
    <div className="certification-tracker">
      <div className="cert-header">
        <h1>🎯 Professional Certifications</h1>
        <p>Exam preparation courses by CrossReg Nexus, with hands-on practice in CrossRegGuard</p>
      </div>

      <div className="cert-grid">
        {/* CAMS — available now */}
        <div className="cert-card cams-featured" onClick={() => setShowCAMSCourse(true)}>
          <div className="cert-icon">🎖️</div>
          <div className="badge-new">NEW</div>
          <h2>CAMS Exam Preparation</h2>
          <p className="cert-provider">CrossReg Nexus</p>
          <div className="cert-description-short">
            Eight study modules covering every CAMS exam area — each with a 10-question knowledge check and 5 hands-on labs in CrossRegGuard — plus an 80-question final practice exam.
          </div>
          <div className="cert-highlights">
            <div className="highlight">📚 8 Modules</div>
            <div className="highlight">📝 Final exam</div>
            <div className="highlight">🛠 40 Labs</div>
            <div className="highlight">🎖️ Certificate</div>
          </div>
          <button className="cert-button cams-start">🚀 Start CAMS Course</button>
        </div>

        {/* Planned courses */}
        {UPCOMING_COURSES.map(course => (
          <div key={course.id} className="cert-card cams-featured coming-soon" aria-disabled="true">
            <div className="cert-icon">{course.icon}</div>
            <div className="badge-new badge-soon">COMING SOON</div>
            <h2>{course.title}</h2>
            <p className="cert-provider">CrossReg Nexus</p>
            <div className="cert-description-short">{course.description}</div>
            <div className="cert-highlights">
              {course.highlights.map(h => <div key={h} className="highlight">{h}</div>)}
            </div>
            <button className="cert-button cams-start" disabled>Coming soon</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CertificationTracker;
